<template>
    <modal :visible="visible">
        <template #header class="d-flex">
            <h2>{{ $t('cdb.subscription.cancelSubscription.title') }}</h2>
            <div class="close-icon" @click="$emit('hide')">
                X
            </div>
        </template>
        <template #body>
            <div>
                <b-form-group class="mb-4">
                    <b-form-radio-group v-model="returnType">
                        <b-form-radio value="pickup">
                            {{ $t('cdb.subscriptions.return.pickup') }}
                        </b-form-radio>
                        <b-form-radio value="self">
                            {{ $t('cdb.subscriptions.return.self') }}
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
                <div class="mb-2 mt-4" v-if="vehicleAddress">
                    <div class="text-bold"> {{ $t('cdb.subscriptions.address') }} </div>
                    <address-box class="subscription-address-box" :address="vehicleAddress"/>
                </div>
                <alert-box class="my-4" v-if="subscription.ends_at">
                    <div class="d-flex my-2">
                        <div>{{ $t('cdb.subscriptions.cancel.date') }}</div>
                        <div class="ml-auto"> {{ subscription.ends_at }}</div>
                    </div>
                    <span v-if="returnType === 'pickup'">
                        <div class="d-flex my-2">
                            <div>{{ $t('cdb.subscription.return.extraCosts') }}</div>
                            <div class="ml-auto"> {{ delivery.result }} </div>
                        </div>
                    </span>
                </alert-box>
                <b-form-checkbox class="pb-1" v-model="agb">
                    <p v-html="$t('co.conclusion.confirm.gtc', {agb: $getUrl('content-page', { path: 'agb' })})"></p>
                </b-form-checkbox>
                <b-form-checkbox v-model="privacyCheck">
                    <p v-html="$t('co.conclusion.confirm.privacy', {agb: $getUrl('content-page', { path: 'datenschutz' })})"></p>
                </b-form-checkbox>
            </div>
        </template>
        <template #footer>
            <b-button :disabled="isButtonDisabled" @click="cancelSubscription" variant="danger" class="ml-auto">
                {{ $t('cdb.subscription.cancelSubscription.submit') }}
            </b-button>
        </template>
    </modal>
</template>

<script>
import Modal from "../atoms/Modal.vue";
import IconPill from "../atoms/IconPill.vue";
import AlertBox from "../atoms/AlertBox.vue";
import AddressBox from "./AddressBox.vue";
import {BButton, BFormGroup, BFormInput, BFormRadio, BFormRadioGroup, BFormCheckbox, BLink} from "bootstrap-vue";

export default {
    name: 'SubscriptionCancelModal',
    components: { Modal, IconPill, AlertBox, BFormGroup, BFormInput, BFormRadio, BButton, BFormRadioGroup, BFormCheckbox, BLink, AddressBox },

    data() {
        return {
            returnType: null,
            agb: false,
            privacyCheck: false,
            delivery: {},
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        subscription: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        isButtonDisabled() {
            return !this.returnType || !this.agb || !this.privacyCheck
        },
        vehicleAddress() {
            return this.subscription.vehicle?.address
        }
    },
    methods: {
        cancelSubscription() {
            this.$emit('cancel-subscription', { returnType: this.returnType, delivery: this.delivery })
        },
        async getDeliveryCalculationData() {
            const vehicleAddress = this.subscription.vehicle?.address
            const response = await this.$axios.post('api/v1/vehicle/delivery_cost', {
                address: vehicleAddress.street + ' ' + vehicleAddress.house_number + ', ' + vehicleAddress.postal_code + ' ' + vehicleAddress.city + ', ' + vehicleAddress.country,
                vehicle_uuid: this.subscription.vehicle.uuid
            })
            this.delivery = response.data
        }
    },
    watch: {
        subscription: {
            handler() {
                this.getDeliveryCalculationData()
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
.subscription-address-box::v-deep {
    p {
        margin: 0;
    }
}

</style>
